import React from "react";

export default function Lotus() {
  return (
    <section className="bg-[#FFFBEF]">
      <div className="w-container-lg flex justify-center blade-top-padding-xl blade-bottom-padding">
        <img
          src="/partnersAndSupport/lotus.png"
          alt="lotus opening"
          className=""
        />
      </div>
    </section>
  );
}
